export default __webpack_public_path__ + "static/media/guarddestroyer2.a8c3d894.png";